const ACCESS_CODE_KEY = 'fwoozie_access_code';

export const storage = {
  getAccessCode(): string | null {
    try {
      return localStorage.getItem(ACCESS_CODE_KEY);
    } catch (error) {
      console.error('Error reading from localStorage:', error);
      return null;
    }
  },

  setAccessCode(code: string): void {
    try {
      localStorage.setItem(ACCESS_CODE_KEY, code);
    } catch (error) {
      console.error('Error writing to localStorage:', error);
    }
  },

  removeAccessCode(): void {
    try {
      localStorage.removeItem(ACCESS_CODE_KEY);
    } catch (error) {
      console.error('Error removing from localStorage:', error);
    }
  },
};
